import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { initAnalytics } from 'services/analyticsService'
import ReactGA from 'react-ga4'

initAnalytics()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)

const sendToAnalytics = ({ id, name, value }) => {
  // GA4 prefers integers. CLS is a very small decimal, so we multiply it by 1000.
  const formattedValue = Math.round(name === 'CLS' ? value * 1000 : value)

  ReactGA.event({
    category: 'Web Vitals',
    action: name,
    value: formattedValue,
    label: id,
    nonInteraction: true,
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals(sendToAnalytics)
//reportWebVitals(console.log)
